import { render } from "./RequestRegisterProductEdit.vue?vue&type=template&id=c3324ba4&scoped=true"
import script from "./RequestRegisterProductEdit.vue?vue&type=script&lang=js"
export * from "./RequestRegisterProductEdit.vue?vue&type=script&lang=js"

import "./RequestRegisterProductEdit.vue?vue&type=style&index=0&id=c3324ba4&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3324ba4"]])

export default __exports__